import { brand } from "../config/brands";
import axios from "axios";

const url = brand.apiBaseUrl

//const url = 'http://localhost:8092/api'

// getCategories
function getCategories() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/category`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getNotifications
function getNotifications() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/notifications`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// get History Driver Between 2 dates
function getDriverHistory(startDate, endDate,driver) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/historyByDriverBetweenTwoDates?startDate=${startDate}&endDate=${endDate}&driverId=${driver}`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getOrdersByDriver
function getOrdersByDriver(driver) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/orderByDriver?driver=${driver}`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

//get Drivers
function getDrivers() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/drivers`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

//get Available Drivers
function getAvailableDrivers() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/active/drivers`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getBusiness
function getBusiness() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/restaurantBackOffice`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


// getBusiness
function getBusinessById(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/restaurant/${id}`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

//getBusinessByIdByCustomer
function getBusinessByIdCustomer(id, customer) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/restaurantByCustomerWebsite/${id}&customer=${customer}`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getAllSubCategories() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/subCategory`)
            .then(function (data) {   
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getCategoryById
function getCategoryById(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/category/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getBanners
function getBanners() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/banner`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// getLabels
function getLabels() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/labels`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function addDriver(phone,firstName, lastName,type, password) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/drivers`, {
          
            phoneNumber: phone,
            first_name: firstName,
            last_name: lastName,
            moto_type: type,
            password: password,
            driverStatus:{
                status_id: "1"
            }
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
} 

function addPromoCode(code, usage, amount,expiredDate) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/promoCode`, {
          
            code: code,
            usage: usage,
            amount: amount,
            expiredDate: expiredDate

        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
}

function addBusiness(id,phone,allHours, email,password,name,description, logo, image, lat, lon, deliveryTime, openingHours,priority, asMarket) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/restaurant`, {
          
            phoneNumber: phone,
            email: email,
            name: name,
            allHours: allHours,
            password: password,
            description: description,
            logo: logo,
            image: image,
            priority: priority,
            likeMarket: asMarket,
            openingHours: openingHours,
            google_map_coordinates:{
                x: lat,
                y: lon
            },
            subCategory:{
                subCategoryId: id
            },
            deliveryTime: deliveryTime

        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
} 


function contactUs(phone, name,subject, message) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/contact`, {
          
            phoneNumber: phone,
            name: name,
            subject: subject,
            message: message
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
} 

function addAddress(name,street, building,apartment,instructions,id,lat,long) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/address`, {
          
            name: name,
            street: street,
            building: building,
            apartment: apartment,
            isDeleted: false,
            instructions: instructions,
            customer:{
                customerId: id
            },
            google_map_coordinates: {
                x: lat,
                z: long
            },
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
} 

// cart 
function addToCarrt(cart, id) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/cart`, {
            product: {
                productId: cart.product.product_id
            },
            quantity: cart.quantity,
            
            customer: {
                customerId: id
            },
            price: cart.price,
            done: false
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// update cart item quantity
function updateItemQuantity(order,product, quantity) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/quantity?quantity=${quantity}&product=${product}&order=${order}`, {}).then(function (data) {
            resolve(data);
        }, error => {
            reject(error.response)
        })
    });
}


function getUserCart(customerId) {
    //console.log('cus', customerId)
    return new Promise((resolve, reject) => {
        axios.get(`${url}/cartByCustomer?customer=${customerId}` )
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteItemcart(cartId) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/cart/${cartId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteMenuCategory(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/menuCat/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteItemcartByProduct(product, customer) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/cartByProduct?product=${product}&customer=${customer}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


// get orders list by customer
function getOrderByCustomer(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/ordersByCustomer?customer=${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// get orders list by customer and status
function getOrderByStatus(status) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/ordersByStatus?orderStatus=${status}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// get order by id
function getOrderById(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/order/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function getFeaturedProduct() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/featured`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getRecentlyAddedProduct() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/recentlyAdded`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getSimilarProducts(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/similarPro/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getProductsByCategory(cat) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/byCategory?menuCategory=${cat}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function returnProductsByCategory(cat) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/findProducts?category=${cat}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function findByBarcode(bar) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/productByBarcode?barcode=${bar}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function findBusinessByPhoneNumber(number) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/restaurantByPhoneNumber?phoneNumber=${number}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function findCustomersByBusiness(business) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/customers/${business}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getProducts() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/products`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function addUser(id,fn, ln,email, num) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/customer`, {
          
            customerId: id,
            firstName: fn,
            lastName: ln,
            email: email,
            phoneNumber: num,
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
} 

function addFavorite(favorite, token) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/favorites`, {
            product: { productId: favorite.productId },
            customer: { customerId: favorite.customerId },
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getFavoriteByID(productId) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/favorite/${productId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getFavoriteByCustomer(customerId) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/favorite/user?customer=${customerId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getFavoriteByProduct(productId) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/favorites/product?product=${productId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getFavoriteByProductAndCustomer(customerId, productId) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/favoriteProductUser?customer=${customerId}&product=${productId}`, {
        
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteFavorite(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/favorites/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


//update User
function updateCustomer(id, name, email) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/customer/${id}`,{
            firstName: name,
            email: email,
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function updatePromo(code, usage, amount, expiredDate,id) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/promoCode/${id}`,{
            code: code,
            amount: amount,
            expiredDate: expiredDate,
            usage: usage
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getAddressById(id) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/address/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}



function editMenuCategory(id,name, priority) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/menuCat/${id}`,{
            name: name,
            priority: priority,
      
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function updateaddress(name,street, building,apartment,instructions,id) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/address/${id}`,{
            name: name,
            street: street,
            building: building,
            apartment: apartment,
            instructions: instructions,
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteAddress(id) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/deleteAddress/${id}`,{
          
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function clearCart(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/clearCart?customer=${id}`,{
          
        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function checkPromoCode(code,id){
    return new Promise((resolve, reject) => {
        axios.get(`${url}/checkPromoCode?code=${code}&customer=${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function reorder(id){
    return new Promise((resolve, reject) => {
        axios.get(`${url}/reorder/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function listOrderStatus(){
    return new Promise((resolve, reject) => {
        axios.get(`${url}/orderStatus`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getCustomers(){
    return new Promise((resolve, reject) => {
        axios.get(`${url}/customers`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getSupportt(){
    return new Promise((resolve, reject) => {
        axios.get(`${url}/contact`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

// update status Order
function updateOrderStatus(id,status) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/updateStatus/${id}?orderStatus=${status}`, {}).then(function (data) {
            resolve(data);
        }, error => {
            reject(error.response)
        })
    });
}

function getAllPendingOrders() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/getAllPendingOrders`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getAllPendingOrdersByBusiness(business) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/getAllPendingOrdersByBusiness?business=${business}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}



function getAllOrders() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/orders`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getAllOrdersByBusiness(business) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/ordersByBusiness?business=${business}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getReport() {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/report`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getReportByBusiness(business) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/reportByBusiness?business=${business}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function filterOrdersByDate(end) {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/reportByDate?date=${end}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function getReportBetweenDates (restaurant, date, toDate) {
    console.log(`${url}/reportBetween?restaurantId=${restaurant}&date=${date}&toDate=${toDate}`)
    return new Promise((resolve, reject) => {
        axios.get(`${url}/reportBetween?restaurantId=${restaurant}&date=${date}&toDate=${toDate}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getNewMessages(){
    
    return new Promise((resolve, reject) => {
        axios.get(`${url}/newMessage`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getPromoCode(){
    
    return new Promise((resolve, reject) => {
        axios.get(`${url}/promoCodes`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function getOrderStatus () {
    return new Promise((resolve, reject) => {
        axios.get(`${url}/orderStatus`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function markRead (id) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/markAsRead/${id}`, {}).then(function (data) {
            resolve(data);
        }, error => {
            reject(error.response)
        })
    });
}

function deleteOrder(orderId) {
    console.log(`${url}/order/${orderId}`)
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/order/${orderId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteNotification(notId) {
    console.log(`${url}/notification/${notId}`)
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/notification/${notId}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteBusiness(id) {
    console.log(`${url}/restaurant/${id}`)
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/restaurant/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function deleteProduct(id) {
    console.log(`${url}/product/${id}`)
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/product/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}


function updateLabel(phone,location, email,causeTitle,causeDesc,aboutUs, aboutUsLink, privacyPolicy, privacyPolicyLink, dollarRate, deliveryCharge,id,baseDeliveryFee, baseKm, pricePerExtraKm, extraKm) {
    return new Promise((resolve, reject) => {
        axios.put(`${url}/label/${id}`,{
            phoneNumber: phone,
            location: location,
            email: email,
            causeTitle: causeTitle,
            causeDesc: causeDesc,
            aboutUs: aboutUs,
            aboutUsLink: aboutUsLink,
            privacyPolicy: privacyPolicy,
            privacyPolicyLink: privacyPolicyLink,
            dollarRate: dollarRate,
            deliveryCharge: deliveryCharge,
            baseDeliveryFee: baseDeliveryFee,
            baseKm: baseKm,
             pricePerExtraKm: pricePerExtraKm,
             extraKm: extraKm


        })
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function addBanner(image,priority,businessId, menuCatId, productId) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/banner`, {
          
            image: image,
            priority: priority,
            business: businessId ? {
                restaurant_id: businessId
            }: null,
            menuCategory: menuCatId ? {
                menuCatId: menuCatId
            }: null,
            product: productId ? {
                productId: productId
            }: null,
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
}

function deleteBanner(id) {
    return new Promise((resolve, reject) => {
        axios.delete(`${url}/banner/${id}`)
            .then(function (data) {
                resolve(data);
            }, error => {
                reject(error.response)
            })
    });
}

function saveNotification(title,description,id) {
    return new Promise((resolve, reject) => {
        axios.post(`${url}/save-Notification`, {
          
            title: title,
            description: description,
            customer: id ? {
                customerId: id
            }: null,
        })
            .then(function (data) {
                resolve(data);
            
               
            }, error => {
                reject(error.response)
            })
    });
}

export {
  
    getCategories,
    getBanners,
    getLabels,
    contactUs,
    addAddress,
    addToCarrt,
    updateItemQuantity,
    getUserCart,
    deleteItemcart,
    getOrderByCustomer,
    getOrderById,
    getFeaturedProduct,
    getRecentlyAddedProduct,
    getSimilarProducts,
    getProductsByCategory,
    addUser,
    addFavorite,
    getFavoriteByID,
    deleteFavorite,
    getFavoriteByCustomer,
    getFavoriteByProduct,
    getFavoriteByProductAndCustomer,
    updateCustomer,
    getProducts,
    getAddressById,
    updateaddress,
    deleteAddress,
    clearCart,
    checkPromoCode,
    findByBarcode,
    deleteItemcartByProduct,
    reorder,
    listOrderStatus,
    getOrderByStatus,
   getCategoryById,
   returnProductsByCategory,
   getCustomers,
   getSupportt,
   updateOrderStatus,
   getAllPendingOrders,
   getAllOrders,
   getReport,
   filterOrdersByDate,
   getOrderStatus,
   getBusiness,
   getBusinessById,
   getReportBetweenDates,
   getNewMessages,
   markRead,
   getDrivers,
   addDriver,
   deleteOrder,
   addBusiness,
   deleteBusiness,
   updateLabel,
   addBanner,
   deleteBanner,
   deleteMenuCategory,
   editMenuCategory,
   deleteProduct,
   getPromoCode,
   addPromoCode,
   updatePromo,
   getOrdersByDriver,
   getDriverHistory,
   saveNotification,
   getAvailableDrivers,
   getAllPendingOrdersByBusiness,
   getAllOrdersByBusiness,
   getReportByBusiness,
   findBusinessByPhoneNumber,
   findCustomersByBusiness,
   getAllSubCategories,
   getNotifications,
   deleteNotification,
   getBusinessByIdCustomer


    
}